import { createStyles, makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) { return createStyles({
    container: {
        marginLeft: theme.spacing(2),
    },
    popper: {
        zIndex: theme.zIndex.drawer,
    },
    paper: {
        borderRadius: '8px',
    },
}); });
//# sourceMappingURL=notificationStyles.js.map